import gql from 'graphql-tag'

export const CARGO_FRAGMENT = gql`
  fragment CargoFragment on Cargo {
    id
    nome
  }
`

export const CARGOS_BY_USUARIO_QUERY = gql`
  ${CARGO_FRAGMENT}
  query CargosByUsuario($usuarioId: ID) {
    cargos(usuarioId: $usuarioId) {
      ...CargoFragment
      dealer {
        id
        nome
      }
      departamento {
        id
        nome
      }
      dataInicio
    }
  }
`

export const CARGOS_QUERY = gql`
  ${CARGO_FRAGMENT}
  query Cargos($cargosPrincipais: [ID!]) {
    cargos(cargosPrincipais: $cargosPrincipais) {
      ...CargoFragment
    }
  }
`

export const PODE_ADICIONAR_CARGO_QUERY = gql`
  query PodeAdicionarCargo($podeAdicionarCargoInput: PodeAdicionarCargoInput!) {
    podeAdicionarCargo(podeAdicionarCargoInput: $podeAdicionarCargoInput)
  }
`
